import { Link } from "react-router-dom";

export default function AuthShell({ children, title, subtitle, testid }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.05fr_.95fr]" data-testid={testid}>
      {/* Left: form */}
      <div className="flex flex-col px-6 sm:px-12 lg:px-20 py-8">
        <Link to="/" className="inline-flex items-center gap-3 mb-12" data-testid="auth-brand-home">
          <img src="/assets/kidpath-mark-light.png" alt="" className="h-11 w-auto" />
          <span className="font-display text-3xl font-extrabold leading-none">
            <span style={{ color: "var(--logo-navy)" }}>Kid</span>
            <span style={{ color: "var(--logo-teal)" }}>Path</span>
          </span>
        </Link>
        <div className="flex-1 flex flex-col justify-center max-w-md w-full mx-auto lg:mx-0">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-kid-navy mb-2">{title}</h1>
          {subtitle && <p className="text-kid-muted mb-8">{subtitle}</p>}
          {children}
        </div>
        <p className="text-xs text-kid-muted/80 max-w-md mx-auto lg:mx-0 mt-10 leading-relaxed">
          KidPath provides information and navigation, not medical, legal, or tax advice, and does not
          determine eligibility or guarantee funding.
        </p>
      </div>

      {/* Right: warm brand panel */}
      <div className="hidden lg:flex relative overflow-hidden items-center justify-center p-16"
           style={{ background: "linear-gradient(135deg,#EAF6FD 0%,#E4F6F1 55%,#F3F0FF 100%)" }}>
        <div className="relative z-10 max-w-md">
          <span className="inline-flex items-center gap-2 font-poppins font-semibold text-[.72rem] tracking-[.14em] uppercase text-kid-teal bg-white px-4 py-2 rounded-full shadow-sm">
            <span className="w-2 h-2 rounded-full bg-kid-coral" /> A calmer path
          </span>
          <h2 className="text-4xl font-extrabold text-kid-navy mt-6 leading-tight">
            You are not alone. There is a path forward.
          </h2>
          <p className="text-kid-muted mt-4 text-lg">
            Understand funding, tax credits, school supports and next steps — with less overwhelm and
            more confidence.
          </p>
          <div className="mt-8 rounded-2xl bg-white shadow-lg p-5 w-72">
            <div className="flex items-center gap-3 mb-3">
              <div className="ring" style={{ "--p": 57, width: 46, height: 46, position: "relative", flex: "none", borderRadius: "50%", background: "conic-gradient(var(--teal) calc(57*1%),#E6EEF3 0)", display: "grid", placeItems: "center" }}>
                <b className="relative font-display text-xs text-kid-navy">4/7</b>
              </div>
              <div>
                <div className="font-display font-bold text-kid-navy text-sm">Your family roadmap</div>
                <div className="text-xs text-kid-muted font-poppins">Guided · updated monthly</div>
              </div>
            </div>
            <div className="text-[.8rem] text-kid-ink/80 space-y-1.5">
              <div className="flex gap-2"><span className="text-kid-green">✓</span> Disability Tax Credit — worth reviewing</div>
              <div className="flex gap-2"><span className="text-kid-sun">✓</span> School meeting prep pack</div>
              <div className="flex gap-2"><span className="text-kid-sky">•</span> Documents to gather</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
